<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title mb-4">Film & Performance Taking Report</div>

      <div class="mt-3 mb-4 border-bottom" style="zoom: 0.9;">
        <div class="row">
          <!-- SELECT CINEMA -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div>
              <div class="dropdown-curve-container">
                <label :class="selectedCinemaObj ? 'shift-up' : ''">{{
                  $tc("")
                }}</label>
                <multiselect
                  v-model="selectedCinemaObj"
                  :options="Cinemas"
                  :multiple="false"
                  :group-select="true"
                  placeholder="Select Cinema"
                  track-by="cine_id"
                  label="cine_name"
                ></multiselect>
              </div>
            </div>
          </div>

          <div class="col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button class="btn-clearDate">✖</button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="FilmWise.start_date"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="filmwise_startdate"
                    name="filmwise_startdate"
                    v-validate="'required'"
                    @selected="onChangeDate($event, 'from')"
                  ></Datepicker>
                </div>
                <label :class="FilmWise.start_date ? 'active' : ''">{{
                  $t("startdate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-xl-2 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker custom-date">
                <button class="btn-clearDate">✖</button>
                <div class="d-flex align-items-center">
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="FilmWise.end_date"
                    type="date"
                    class="theme-custom-date-time w-100"
                    typeable
                    id="filmwise_enddate"
                    name="filmwise_enddate"
                    v-validate="'required'"
                  ></Datepicker>
                </div>
                <label :class="FilmWise.end_date ? 'active' : ''">{{
                  $t("enddate")
                }}</label>
              </div>
            </div>
          </div>

          <div class="col-xl-3 align-self-center mb-3">
            <div class="d-flex align-items-center">
              <b-form-radio
                :value="'Y'"
                class="j-radio"
                v-model="is_transaction_date"
              >
                <div>
                  <span>{{ "Transaction Date" }}</span>
                </div>
              </b-form-radio>
              <strong class="mx-3">OR</strong>

              <b-form-radio
                :value="'N'"
                class="j-radio"
                v-model="is_transaction_date"
              >
                <div>
                  <span>{{ "Show Date" }}</span>
                </div>
              </b-form-radio>
            </div>
          </div>

          <!-- SELECT DISTRIBUTOR -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedDistributors.length ? 'shift-up' : ''"
                >Select Distributor</label
              >
              <multiselect
                v-model="selectedDistributors"
                :options="Distributor"
                :multiple="true"
                label="d_company_name"
                track-by="d_id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Distributor"
                @input="getselectedDistibutor()"
              ></multiselect>
            </div>
          </div>

          <!-- SELECT MOVIE -->
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedMovies.length ? 'shift-up' : ''"
                >Select Movies</label
              >
              <multiselect
                v-model="selectedMovies"
                :options="MovieList"
                :multiple="true"
                label="movie"
                track-by="md_id"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Select Movie"
              ></multiselect>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              @click="getFilmWiseCollectionReport()"
              class="btn btn-sm btn-primary w-100"
            >
              {{ $tc("Fetch") }}
            </button>
          </div>

          <div
            v-if="tableData.length > 0"
            class="col-lg-6 col-xl-4 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div>{{ $t("download") }} as:</div>
            <!-- <a href="#" @click="generateReport()" title="Download as PDF">
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                class="mx-1"
                height="25"
                width="25"
              />
            </a> -->
            <a
              target="_blank"
              @click="getFilmWiseCollectionReport('Y', 'N')"
              download
              title="Download as PDF"
            >
              <img
                src="@/assets/img/icons/pdf-icon.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              href="#"
              @click="getFilmWiseCollectionReport('N', 'Y')"
              title="Download as Excel"
            >
              <img src="@/assets/img/icons/excel.svg" height="25" width="25" />
            </a>
          </div>
        </div>
      </div>

      <div class="">
        <div class="table-responsive">
          <table class="report-table">
            <thead>
              <tr>
                <th colspan="7">Performance Details</th>
                <th colspan="5">Ticket Sales</th>
                <th>Ticket Available</th>
              </tr>
              <tr>
                <th>Movie</th>
                <th>Screen</th>
                <th>Distributor</th>
                <th>Start Date</th>
                <th>Start Time</th>
                <th>Capacity</th>
                <th>Sold</th>
                <th>% Sold</th>
                <th>Compl</th>
                <th>% Compl</th>
                <th>Gross</th>
                <th>Discount</th>
                <th>Available</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in tableData" :key="row.t_id">
                <td class="text-left">{{ row.movie_name }}</td>
                <td class="text-left">{{ row.screen_name }}</td>
                <td class="text-left">{{ row.dist_company_name }}</td>
                <td class="text-center">{{ row.show_date }}</td>
                <td class="text-center">{{ row.t_show_time }}</td>
                <td class="text-right">
                  {{ row.capacity || defaultCapacity }}
                </td>
                <td class="text-right">{{ row.Sold }}</td>
                <td class="text-right">
                  {{
                    parseFloat(
                      (parseInt(row.Sold) / parseInt(row.capacity)) * 100
                    ).toFixed(2)
                  }}
                </td>
                <td class="text-right">{{ row.complementary_admits }}</td>
                <td class="text-right">
                  {{
                    parseFloat(
                      (parseInt(row.complementary_admits) /
                        parseInt(row.Sold)) *
                        100
                    ).toFixed(2)
                  }}
                </td>
                <td class="text-right">{{ currFormat(row.gross_amount) }}</td>
                <td class="text-right">{{ currFormat(row.offer_price) }}</td>
                <td class="text-right">
                  {{ (row.capacity || defaultCapacity) - (row.Sold || 0) }}
                </td>
              </tr>
              <tr v-if="tableData.length === 0">
                <td colspan="14" class="text-muted">No records found</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReportsService from "@/services/ReportsService-v2";
import MasterService from "@/services/MasterService";
import MovieService from "@/services/MovieService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import { createQueryString } from "../../../services/ApiHelper";

export default {
  name: "PerformanceReport",
  data() {
    return {
      is_transaction_date: "N",
      selectedCinemaObj: null,
      selectedCinema: [],
      selectedMovies: [],
      selectedDistributors: [],
      Cinemas: [],
      isRoleID: false,
      CinemasLoading: false,

      Distributor: [],
      MovieList: [],

      FilmWise: {
        start_date: new Date(),
        end_date: new Date(),
        selectedDistributor: "",
        selectedMovie: "",
        filmWiseCollectionResult: [],
        filmWiseTotalCharges: "",
        finalArr: []
      },
      tableData: [],
      defaultCapacity: 0
    };
  },
  computed: {
    // handy computed to send minimal payload to API
    selectedCinemaIds() {
      return (this.selectedCinema || []).map(c => c.cine_id);
    }
  },
  mounted() {
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }
    let cinemaId =
      this.secureStore.get("USINFO") &&
      this.secureStore.get("USINFO")["cinema_id"]
        ? this.secureStore.get("USINFO").cinema_id
        : null;
    this.getCinemaList(cinemaId);
    this.fetchDistributorsList();
    this.getMoviesList();
  },
  methods: {
    getCinemaList(cine_id) {
      MasterService.GetCinemasByRoles({ cine_id: cine_id })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._catchError);
    },
    fetchDistributorsList() {
      MasterService.GetAllDistributors({ is_Active: "Y" })
        .then(response => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.Distributor = data.Records;
            console.log(this.Distributor);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._catchError);
    },
    getMoviesList() {
      MovieService.GetActiveMoviesWithFormat({
        cinema_id: this.selectedCinema[0],
        movieversions: "Y"
      }).then(response => {
        const { data } = response;
        if (data.status && data.Records.length > 0) {
          this.MovieList = data.Records;
        }
      });
    },
    getFilmWiseCollectionReport(isPdf = "N", isExcel = "N") {
      if (!this.selectedCinemaObj["cine_id"]) {
        this.$toasted.show("Select Cinema");
        return false;
      }

      let payload = {
        fromDate: moment(this.FilmWise.start_date).format("YYYY-MM-DD"),
        toDate: moment(this.FilmWise.end_date).format("YYYY-MM-DD"),
        cinema_id: this.selectedCinemaObj["cine_id"],
        cinema_name: this.selectedCinema.map(z => z.cine_name),
        cinema_address: this.selectedCinema.map(z => z.cine_address),
        movieIds: this.selectedMovies.map(z => z.md_id),
        distributorIds: this.selectedDistributors.map(z => z.d_id),
        multiple_cinema_id: [this.selectedCinemaObj["cine_id"]],
        isTransactionDate: this.is_transaction_date || "N",
        isPdf: isPdf || "N",
        isExcel: isExcel || "N"
      };
      let loader = this.$loading.show();
      ReportsService.GetFilmPerformaneTakingReport(payload)
        .then(response => {
          const { data } = response;
          if (data.status && data.data.length > 0) {
            this.tableData = data.data;
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            if (data.excelPath && isExcel == "Y") {
              window.open(data.excelPath, "_blank");
            }
          } else {
            this.tableData = [];
            this.$toasted.show(data.message);
          }
        })
        .catch(err => {
          console.log("Error:", err);
        })
        .finally(() => {
          setTimeout(() => loader.hide(), 500);
        });
    },
    formatCurrency(value) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
        minimumFractionDigits: 0
      }).format(Number(value || 0));
    },

    onChangeDate: function(e, type) {
      if (type == "from") {
        this.FilmWise.end_date = new Date(e);
        this.$forceUpdate();
      }
    },
    moment,

    getselectedDistibutor() {
      console.log("this.getDist", this.FilmWise.selectedDistributor);
    },
    getDateValues() {
      console.log(
        "this.getDist",
        moment(this.FilmWise.end_date).format("YYYY-MM-DD")
      );
    },
    excelDownload() {
      console.log("Excel Download clicked, rows:", this.tableData.length);
    }
  }
};
</script>

<style scoped>
.report-container {
  padding: 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.08);
}

.table-responsive {
  overflow: auto;
  max-height: 60vh;
}

.report-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  min-width: 1200px;
}

.report-table th,
.report-table td {
  border: 1px solid #eaeaea;
  padding: 8px;
  text-align: center;
  white-space: nowrap;
}

.report-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  font-weight: 600;
  text-transform: uppercase;
  font-size: 12px;
}

.report-table tr:nth-child(even) {
  background-color: #fbfbfb;
}

.left {
  text-align: left;
  padding-left: 14px;
  max-width: 300px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.text-muted {
  color: #777;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/FilmPerformanceAndTakingReport.vue